const config = {
    server: document.location.protocol + "//" + document.location.hostname + ":3001",
    eventserver: document.location.hostname + ":3000",
}

export default config